"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const axios_1 = __importDefault(require("axios"));
const CancelToken = axios_1.default.CancelToken;
const access_token_1 = __importDefault(require("../models/access-token"));
const isomorphic_ws_1 = __importDefault(require("isomorphic-ws"));
const util_1 = require("./util");
const BASE_URL = 'https://v1.api.gridduck.com/';
const SOCKET_URL = 'wss://v1.api.gridduck.com';
const SOCKET_PING_INTERVAL = 10000;
const formUrlEncoded = function (x) {
    return Object.keys(x).reduce((p, c) => p + `&${c}=${encodeURIComponent(x[c])}`, '');
};
class BaseApiService {
    set config(value) {
        this._config = value;
        if (this._config.accessToken) {
            this.openSocket();
        }
    }
    constructor(config) {
        this.socket = null;
        this.lastPinged = 0;
        this.visibleObjects = null;
        this.onLoggedOutCallback = [];
        this.onLoggedInCallback = [];
        this.onLostConnectionCallback = [];
        this.onOpenedConnectionCallback = [];
        this.accessTokenPromise = null;
        this.pingSendTimeout = null;
        this.pingedOutTimeout = null;
        const self = this;
        this.socketCallback = null;
        this.interval = null;
        this._config = config;
        this.cancelToken = new CancelToken(function executor(c) {
            self.cancelQueries = c;
        });
    }
    closeSocket() {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                if (this.socket) {
                    if (this.socket.close) {
                        this.socket.close();
                    }
                    if (this.socket.terminate) {
                        this.socket.terminate();
                    }
                    this.socket = null;
                }
            }
            catch (e) {
            }
        });
    }
    openSocket(instance) {
        return __awaiter(this, void 0, void 0, function* () {
            let self = this;
            if (instance) {
                self = instance;
            }
            if (self.socket) {
                return Promise.resolve();
            }
            if (self.pingSendTimeout) {
                clearInterval(self.pingSendTimeout);
            }
            if (self.pingedOutTimeout) {
                clearInterval(self.pingedOutTimeout);
            }
            let socketUrl = self._config.baseUrl ? self._config.baseUrl.replace('http://', 'ws://').replace('https://', 'wss://') : SOCKET_URL;
            self.socket = new isomorphic_ws_1.default(socketUrl);
            function pingedOut() {
                if (new Date().getTime() - self.lastPinged > SOCKET_PING_INTERVAL + 2000) {
                    sendPing();
                    heartbeat();
                }
                else {
                    if (self.socket) {
                        if (self.socket.terminate) {
                            self.socket.terminate();
                        }
                        if (self.socket.close) {
                            self.socket.close();
                        }
                    }
                    self.onLostConnectionCallback.forEach(function (lostConnectionCallback) {
                        lostConnectionCallback();
                    });
                }
            }
            function heartbeat() {
                if (self.pingedOutTimeout) {
                    clearTimeout(self.pingedOutTimeout);
                }
                self.pingedOutTimeout = setTimeout(pingedOut, (SOCKET_PING_INTERVAL * 2) + 2000);
            }
            function sendPing() {
                self.lastPinged = new Date().getTime();
                if (self.socket) {
                    try {
                        self.socket.send('ping');
                    }
                    catch (e) {
                    }
                }
                if (self.pingSendTimeout) {
                    clearTimeout(self.pingSendTimeout);
                }
                self.pingSendTimeout = setTimeout(sendPing, SOCKET_PING_INTERVAL);
            }
            self.socket.onopen = function () {
                if (!self._config.accessToken) {
                    return self.closeSocket();
                }
                sendPing();
                heartbeat();
                try {
                    self.socket.send(JSON.stringify({ accessToken: self._config.accessToken.token }));
                    setTimeout(function () {
                        self.onOpenedConnectionCallback.forEach(function (openConnectionCallback) {
                            openConnectionCallback();
                        });
                    }, 200);
                }
                catch (e) {
                    pingedOut();
                }
            };
            self.socket.onmessage = function (message) {
                let messageString = message.data.toString();
                if (messageString === 'pong') {
                    heartbeat();
                }
                else {
                    let messageObj = JSON.parse(messageString);
                    if (self.socketCallback && !document.hidden) {
                        self.socketCallback(messageObj);
                    }
                }
            };
            self.socket.onclose = function (event) {
                self.onLostConnectionCallback.forEach(function (lostConnectionCallback) {
                    lostConnectionCallback();
                });
                setTimeout(() => self.openSocket(self), 5000);
                self.socket = null;
                if (self.pingSendTimeout) {
                    clearTimeout(self.pingSendTimeout);
                }
                if (self.pingedOutTimeout) {
                    clearTimeout(self.pingedOutTimeout);
                }
                self.pingSendTimeout = null;
                self.pingedOutTimeout = null;
            };
            self.socket.onerror = function (err) {
                self.onLostConnectionCallback.forEach(function (lostConnectionCallback) {
                    lostConnectionCallback();
                });
                self.socket = null;
                setTimeout(() => self.openSocket(self), 5000);
            };
            self.pingedOutTimeout = setTimeout(pingedOut, SOCKET_PING_INTERVAL + 2000);
            return Promise.resolve();
        });
    }
    getAccessToken(username = undefined, password = undefined) {
        return __awaiter(this, void 0, void 0, function* () {
            let self = this;
            let b64EncodedAuth = Buffer.from(this._config.apiKey + ":" + this._config.apiSecret).toString('base64');
            let formData = {
                'grant_type': this._config.type === 'password' ? 'password' : 'client_credentials',
                'scope': this._config.scopes.join(',')
            };
            if (this._config.type === 'password') {
                if (!username) {
                    return Promise.reject("No username specified");
                }
                if (!password) {
                    return Promise.reject("No password specified");
                }
                formData['username'] = username;
                formData['password'] = password;
            }
            let baseUrl = self._config.baseUrl ? self._config.baseUrl : BASE_URL;
            let config = {
                url: baseUrl + 'oauth/token',
                data: formUrlEncoded(formData),
                headers: {
                    'Authorization': 'Basic ' + b64EncodedAuth
                },
                method: "POST"
            };
            return (0, axios_1.default)(config).then(function (res) {
                self._config.accessToken = new access_token_1.default(res.data.access_token, res.data.token_type, new Date(new Date().getTime() + parseInt(res.data.expires_in)), res.data.scope.split(','), res.data.mfa_required, res.data.user);
                if (res.data.mfa_required) {
                    return Promise.reject("MFA_REQUIRED");
                }
                if (res.data.mfa_requires_setup) {
                    return Promise.reject("MFA_SETUP_REQUIRED");
                }
                return self.openSocket().then(function () {
                    self.onLoggedInCallback.forEach(function (loggedInCallback) {
                        loggedInCallback();
                    });
                    return Promise.resolve();
                });
            }).catch(function (err) {
                if (err === 'MFA_REQUIRED') {
                    return Promise.reject("MFA Required");
                }
                if (err === 'MFA_SETUP_REQUIRED') {
                    return Promise.reject("MFA Setup Required");
                }
                if (err.response.status === 401) {
                    let rejectionMessage = "Incorrect Credentials";
                    if (err.response.data === 'Account Locked') {
                        rejectionMessage = "Account Locked";
                    }
                    return Promise.reject(rejectionMessage);
                }
                else {
                    return Promise.reject("Unknown Error");
                }
            });
        });
    }
    submitMFA(mfaString) {
        return __awaiter(this, void 0, void 0, function* () {
            let self = this;
            if (!this._config.accessToken) {
                return Promise.reject("Not logged in");
            }
            let baseUrl = this._config.baseUrl ? this._config.baseUrl : BASE_URL;
            let config = {
                url: baseUrl + 'account/authenticate_token',
                data: { token: mfaString },
                headers: {
                    'Authorization': 'Bearer ' + this._config.accessToken.token
                },
                method: "POST"
            };
            return (0, axios_1.default)(config).then(function (res) {
                if (res.data.success) {
                    return self.openSocket();
                }
                else {
                    return Promise.reject("Incorrect MFA Token");
                }
            }).catch(function (err) {
                if (err.response.status === 401) {
                    return Promise.reject("Not Logged In");
                }
                else {
                    return Promise.reject("Unknown Error");
                }
            });
        });
    }
    setSocketCallback(socketCallback) {
        this.socketCallback = socketCallback;
    }
    setVisibleObjects(visibleObjects) {
        this.visibleObjects = visibleObjects;
        if (this.socket) {
            try {
                this.socket.send(JSON.stringify({
                    visibleObjects: visibleObjects
                }));
            }
            catch (e) {
            }
        }
    }
    runPostQuery(endpoint, body, withFormData, onUploadProgress, isPublic = false, isCompletingMfa = false) {
        return __awaiter(this, void 0, void 0, function* () {
            let self = this;
            let promise = Promise.resolve();
            if (!this._config.accessToken && !this.accessTokenPromise && !isPublic) {
                promise = this.getAccessToken();
                this.accessTokenPromise = promise;
            }
            else if (this.accessTokenPromise && !isCompletingMfa && !isPublic) {
                promise = this.accessTokenPromise;
            }
            let headers;
            if (isPublic) {
                headers = {};
            }
            else {
                headers = {
                    'Authorization': 'Bearer ' + self._config.accessToken.token
                };
            }
            let bodyFormData;
            if (withFormData) {
                bodyFormData = new FormData();
                Object.keys(body).forEach(function (key) {
                    bodyFormData.append(key, body[key]);
                });
                headers['Content-Type'] = 'multipart/form-data';
            }
            return promise.then(function () {
                let baseUrl = self._config.baseUrl ? self._config.baseUrl : BASE_URL;
                let url = baseUrl + endpoint;
                let promise;
                if (typeof navigator != 'undefined' && navigator.product == 'ReactNative' && bodyFormData) {
                    let config = {
                        method: 'POST',
                        body: bodyFormData ? bodyFormData : body,
                        headers: headers
                    };
                    if (onUploadProgress) {
                        config.onUploadProgress = onUploadProgress;
                    }
                    return fetch(url, config)
                        .then(function (data) {
                        return data.json();
                    }).then(function (res) {
                        let response = body || {};
                        Object.keys(body).forEach(function (key) {
                            response[key] = res[key];
                        });
                        return Promise.resolve(response);
                    });
                }
                else {
                    let config = {
                        method: 'post',
                        url: url,
                        data: bodyFormData ? bodyFormData : body,
                        headers: headers
                    };
                    if (onUploadProgress) {
                        config.onUploadProgress = onUploadProgress;
                    }
                    return (0, axios_1.default)(config).then(function (res) {
                        let response = body || {};
                        Object.keys(res.data).forEach(function (key) {
                            response[key] = res.data[key];
                        });
                        return Promise.resolve(response);
                    });
                }
            });
        });
    }
    runPutQuery(endpoint, body, isPublic = false) {
        return __awaiter(this, void 0, void 0, function* () {
            let self = this;
            let promise = Promise.resolve();
            if (!this._config.accessToken && !this.accessTokenPromise && !isPublic) {
                promise = this.getAccessToken();
                this.accessTokenPromise = promise;
            }
            else if (this.accessTokenPromise) {
                promise = this.accessTokenPromise;
            }
            return promise.then(function () {
                let baseUrl = self._config.baseUrl ? self._config.baseUrl : BASE_URL;
                let url = baseUrl + endpoint;
                let config = {
                    method: 'put',
                    url: url,
                    data: body,
                };
                if (!isPublic) {
                    config.headers = {
                        'Authorization': 'Bearer ' + self._config.accessToken.token
                    };
                }
                return (0, axios_1.default)(config).then(function (res) {
                    return Promise.resolve();
                });
            });
        });
    }
    runDeleteQuery(endpoint, id, isPublic = false) {
        return __awaiter(this, void 0, void 0, function* () {
            let self = this;
            let promise = Promise.resolve();
            if (!this._config.accessToken && !this.accessTokenPromise && !isPublic) {
                promise = this.getAccessToken();
                this.accessTokenPromise = promise;
            }
            else if (this.accessTokenPromise) {
                promise = this.accessTokenPromise;
            }
            return promise.then(function () {
                let baseUrl = self._config.baseUrl ? self._config.baseUrl : BASE_URL;
                let url = baseUrl + endpoint + '/' + id;
                let config = {
                    method: 'delete',
                    url: url,
                };
                if (!isPublic) {
                    config.headers = {
                        'Authorization': 'Bearer ' + self._config.accessToken.token
                    };
                }
                return (0, axios_1.default)(config).then(function (res) {
                    return Promise.resolve();
                });
            });
        });
    }
    runSingleGetQuery(endpoint, id, isPublic = false) {
        return __awaiter(this, void 0, void 0, function* () {
            let promise = Promise.resolve();
            if (!this._config.accessToken && !this.accessTokenPromise && !isPublic) {
                promise = this.getAccessToken();
                this.accessTokenPromise = promise;
            }
            else if (this.accessTokenPromise) {
                promise = this.accessTokenPromise;
            }
            let self = this;
            return promise.then(function () {
                let baseUrl = self._config.baseUrl ? self._config.baseUrl : BASE_URL;
                let url = baseUrl + endpoint + '/' + id;
                let config = {
                    url: url,
                };
                if (!isPublic) {
                    config.headers = {
                        'Authorization': 'Bearer ' + self._config.accessToken.token
                    };
                }
                return (0, axios_1.default)(config);
            }).then(function (res) {
                return res.data;
            });
        });
    }
    runGetQuery(endpoint, params, isPublic = false) {
        return __awaiter(this, void 0, void 0, function* () {
            let promise = Promise.resolve();
            if (!this._config.accessToken && !this.accessTokenPromise && !isPublic) {
                promise = this.getAccessToken();
                this.accessTokenPromise = promise;
            }
            else if (this.accessTokenPromise) {
                promise = this.accessTokenPromise;
            }
            let results = [];
            let self = this;
            let baseUrl = self._config.baseUrl ? self._config.baseUrl : BASE_URL;
            let paginatedQuery = function (offset, limit) {
                return __awaiter(this, void 0, void 0, function* () {
                    let url = baseUrl + endpoint + '?offset=' + offset + '&limit=' + limit;
                    params.filters.forEach(function (filter) {
                        let field = (0, util_1.toSnake)(filter.field);
                        let extantFilterStartIndex = url.indexOf('&' + field + '=');
                        if (~extantFilterStartIndex) {
                            let insertionPoint = url.substr(extantFilterStartIndex + 1).indexOf('&');
                            if (!~insertionPoint) {
                                insertionPoint = url.length;
                            }
                            else {
                                insertionPoint += extantFilterStartIndex + 1;
                            }
                            url = url.slice(0, insertionPoint) + ',' + encodeURIComponent(filter.value) + url.slice(insertionPoint);
                        }
                        else {
                            url += '&' + field + '=' + encodeURIComponent(filter.value);
                        }
                    });
                    if (params.sortBy) {
                        if (~url.indexOf('&')) {
                            url += '&sortByField=' + params.sortBy.field;
                        }
                        else {
                            url += '?sortByField=' + params.sortBy.field;
                        }
                        url += '&sortByType=' + params.sortBy.type;
                    }
                    ;
                    let config = {
                        url: url,
                        cancelToken: self.cancelToken
                    };
                    if (!isPublic) {
                        config.headers = {
                            'Authorization': 'Bearer ' + self._config.accessToken.token
                        };
                    }
                    return (0, axios_1.default)(config).then(function (res) {
                        results = results.concat({ list: res.data.results, id: res.data.request_id });
                        if (res.data.links.next && params.getAll) {
                            return paginatedQuery(offset + limit, limit);
                        }
                        else {
                            return { list: results, total: res.data.pagination.total };
                        }
                    });
                });
            };
            return promise.then(function () {
                return paginatedQuery(params.offset, params.items);
            });
        });
    }
    checkAccessToken() {
        return __awaiter(this, void 0, void 0, function* () {
            let self = this;
            if (!this._config.accessToken) {
                return Promise.reject("No access token set");
            }
            let baseUrl = this._config.baseUrl ? this._config.baseUrl : BASE_URL;
            let url = baseUrl + 'check';
            let config = {
                url: url,
                headers: {
                    'Authorization': 'Bearer ' + this._config.accessToken.token
                }
            };
            return (0, axios_1.default)(config).then(function () {
                self.onLoggedInCallback.forEach(function (loggedInCallback) {
                    loggedInCallback();
                });
                return Promise.resolve();
            }).catch(function (err) {
                return Promise.reject("Unknown Error Checking Access Token");
            });
        });
    }
    login(username, password) {
        return __awaiter(this, void 0, void 0, function* () {
            if (username && password) {
                let promise = this.getAccessToken(username, password);
                this.accessTokenPromise = promise;
                return promise;
            }
            else {
                return Promise.reject("No username or password specified");
            }
        });
    }
    onLoggedOut(loggedOutCallback) {
        return __awaiter(this, void 0, void 0, function* () {
            this.onLoggedOutCallback.push(loggedOutCallback);
        });
    }
    onLoggedIn(loggedInCallback) {
        return __awaiter(this, void 0, void 0, function* () {
            this.onLoggedInCallback.push(loggedInCallback);
        });
    }
    onLostConnection(lostConnectionCallback) {
        return __awaiter(this, void 0, void 0, function* () {
            this.onLostConnectionCallback.push(lostConnectionCallback);
        });
    }
    onOpenConnectionCallback(openConnectionCallback) {
        return __awaiter(this, void 0, void 0, function* () {
            this.onOpenedConnectionCallback.push(openConnectionCallback);
        });
    }
    logout() {
        return __awaiter(this, void 0, void 0, function* () {
            this._config.accessToken = undefined;
            this.closeSocket();
            this.onLoggedOutCallback.forEach(function (loggedoutCallback) {
                loggedoutCallback();
            });
        });
    }
    cancel(reason) {
        let self = this;
        if (this.cancelQueries) {
            this.cancelQueries(reason);
            this.cancelToken = new CancelToken(function executor(c) {
                self.cancelQueries = c;
            });
        }
    }
}
exports.default = BaseApiService;
//# sourceMappingURL=base-api-service.js.map